import React, { Component } from 'react';
import { Icon } from 'ui';
import ClickAwayListener from 'components/shared/ClickAwayListener';

class ThreadOptions extends Component {
  constructor(props) {
    super(props);
    this.state = { active: false };
    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
  }

  showMenu() {
    this.setState({ active: true });
  }

  hideMenu() {
    this.setState({ active: false });
  }

  handleOptionOnClick(e, callback) {
    callback(e);
    this.hideMenu();
  }

  renderOptions() {
    return this.props.options.map((option, i) => (
      <li
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        role="menuitem"
        {...option}
        className="NewDropDown-item"
        onClick={e => this.handleOptionOnClick(e, option.onClick)}
        onKeyDown={e =>
          e.key === 'Enter' && this.handleOptionOnClick(e, option.onClick)
        }
      />
    ));
  }

  render() {
    return (
      <div className="ThreadOptions pos-r">
        <Icon
          name="ellipsis-v"
          className="ThreadOptions-toggle"
          onClick={this.showMenu}
          onKeyDown={e => e.key === 'Enter' && this.showMenu()}
        />
        {this.state.active && (
          <ClickAwayListener
            onClickAway={() => this.hideMenu()}
            touchEvent={false}
          >
            <ul
              className="NewDropDown-list NewDropDown-list--small Animated Animated--popDown"
              ref={node => {
                this.menu = node;
              }}
              children={this.renderOptions()}
            />
          </ClickAwayListener>
        )}
      </div>
    );
  }
}

export default ThreadOptions;
